'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('ky-universal'),
    HTTPError = _require.HTTPError;

var log = require('debug')('ipfs-http-client:lib:error-handler');

var _require2 = require('ipfs-utils/src/env'),
    isNode = _require2.isNode,
    isElectronMain = _require2.isElectronMain;

function isJsonResponse(res) {
  return (res.headers.get('Content-Type') || '').startsWith('application/json');
}

module.exports = /*#__PURE__*/function () {
  var _errorHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input, options, response) {
    var msg, data, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!response.ok) {
              _context.next = 3;
              break;
            }

            // FIXME: remove when fixed https://github.com/sindresorhus/ky-universal/issues/8
            //
            // ky clones the response for each handler. In Node.js the response body is
            // piped to 2 PassThroughs, one becomes the real body and the other is used
            // in the clone.
            //
            // If the body in the clone is not consumed or destroyed the highwater mark
            // will be reached (for large payloads) and stop the real body from flowing.
            if (isNode || isElectronMain) response.body.destroy();
            return _context.abrupt("return");

          case 3:
            _context.prev = 3;

            if (!isJsonResponse(response)) {
              _context.next = 12;
              break;
            }

            _context.next = 7;
            return response.json();

          case 7:
            data = _context.sent;
            log(data);
            msg = data.Message || data.message;
            _context.next = 15;
            break;

          case 12:
            _context.next = 14;
            return response.text();

          case 14:
            msg = _context.sent;

          case 15:
            _context.next = 21;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](3);
            log('Failed to parse error response', _context.t0); // Failed to extract/parse error message from response

            msg = _context.t0.message;

          case 21:
            error = new HTTPError(response); // If we managed to extract a message from the response, use it

            if (msg) {
              error.message = msg;
            }

            throw error;

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 17]]);
  }));

  function errorHandler(_x, _x2, _x3) {
    return _errorHandler.apply(this, arguments);
  }

  return errorHandler;
}();